import React from 'react';

function ShowErrors(props) {
    return (
        <div>
            Errors!   
        </div>
    );
}

export default ShowErrors;